// import { navigate } from "@reach/router";
import { useOperatorNavigate } from "utils/navigationHelper";
const navigate = useOperatorNavigate()

export const redirectDashboard = () => {
  return navigate(`/`);
};

export const redirectPinSetUp = () => {
  return navigate(`/pin-setup`);
};

export const redirectEmailVerfied = () => {
  return navigate(`/email-verified`);
};

export const redirectRolePermissions = () => {
  return navigate(`/roles`);
};
export const redirectRoleAdmins = () => {
  return navigate(`/admins`);
};

export const redirectGenericTokens = () => {
  return navigate(`/generic-token-success`);
};

export const redirectOperatorTokens = () => {
  return navigate(`/operator-token-success`);
};

export const redirectOperator = () => {
  return navigate(`/buy-ticket`);
};

export const redirectCampaign = () => {
  return navigate(`/assign-token`);
};
export const redirectAssignToken = () => {
  return navigate(`/assign-token`);
};
export const redirectTokens = () => {
  return navigate(`/tokens`);
};

export const redirectContact = () => {
  return navigate(`/contacts`);
};
